<template>
<section>
  <b-card class="cissetting mb-1 sticky-top" id="userList-card">
    <b-row>
      <b-col>
        <div id="adminMenu" style="margin-left: 0rem;">
          <b-form-radio
            class="btn-radio"
            v-model="selectedAdminMenu"
            value="account"
            size=""
            button
            @change="adminMenuClick('account')"
            style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
          >
            ACCOUNT
          </b-form-radio>
          <b-form-radio
            class="btn-radio"
            v-if="hasSuperAdminRole()"
            v-model="selectedAdminMenu"
            value="prices"
            size=""
            button
            @change="adminMenuClick('prices')"
            style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
          >
            PRICES
          </b-form-radio>
          <b-form-radio
            class="btn-radio"
            v-model="selectedAdminMenu"
            value="users"
            size=""
            button
            @change="adminMenuClick('users')"
            style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
          >
            USERS
          </b-form-radio>
          <b-form-radio
            class="btn-radio"
            v-if="hasSuperAdminRole()"
            v-model="selectedAdminMenu"
            value="seeds"
            size=""
            button
            @change="adminMenuClick('seeds')"
            style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
          >
            SEEDS
          </b-form-radio>
          <b-form-radio
            class="btn-radio"
            v-if="hasSuperAdminRole()"
            v-model="selectedAdminMenu"
            value="keywords"
            size=""
            button
            @change="adminMenuClick('keywords')"
            style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
          >
            KEYWORDS
          </b-form-radio>
          <b-form-radio
            class="btn-radio"
            v-if="hasSuperAdminRole()"
            v-model="selectedAdminMenu"
            value="synonyms"
            size=""
            button
            @change="adminMenuClick('synonyms')"
            style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
          >
            SYNONYMS
          </b-form-radio>
          <b-form-radio
            class="btn-radio"
            v-if="hasSuperAdminRole()"
            v-model="selectedAdminMenu"
            value="uncategorized"
            size=""
            button
            @change="adminMenuClick('uncategorized')"
            style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
          >
            UNCATEGORIZED
          </b-form-radio>
        </div>
      </b-col>
    </b-row>
  </b-card>




  <b-card class="cissetting mb-0">
    <div class="d-flex align-items-center justify-content-between mb-1">
      <div>
        <b-form-input
          v-model="searchQuery"
          placeholder="Search..."
          type="text"
        />
      </div>
      <div class="d-flex align-items-center">
        <b-button
          v-if="hasSuperAdminRole()"
          variant="primary"
          v-b-modal.add-price-modal
        >
          Add
        </b-button>
      </div>
    </div>

    <b-table
      ref="refPricesTable"
      responsive
      :items="fetchPrices"
      :fields="tableColumns"
      primary-key="id"
      show-empty
      empty-text="해당하는 키워드가 없습니다."
      class="position-relative mb-0"
    >

    { key: 'title', label: 'title', sortable: false },
    { key: 'desc', label: 'description', sortable: false },
    { key: 'price', label: 'price', sortable: false },
    { key: 'period', label: 'period', sortable: false },
    { key: 'maxAnalPeriod', label: 'anal period', sortable: false },
    { key: 'maxCateNum', label: 'max categories', sortable: false },
    { key: 'maxMemNum', label: 'max members', sortable: false },
    { key: 'openMenu', label: 'open menu', sortable: false },


      <!-- Column: Title -->
      <template #cell(title)="data">
        <span class="text-nowrap">
          {{ data.item.title }}
        </span>
      </template>

      <!-- Column: Description -->
      <template #cell(desc)="data">
        <span class="text-nowrap">
          {{ data.item.desc }}
        </span>
      </template>

      <!-- Column: Price -->
      <template #cell(price)="data">
        <span class="text-nowrap">
          {{ data.item.price }}
        </span>
      </template>

      <!-- Column: Period -->
      <template #cell(period)="data">
        <span class="text-nowrap">
          {{ data.item.period }}
        </span>
      </template>

      <!-- Column: maxAnalPeriod -->
      <template #cell(maxAnalPeriod)="data">
        <span class="text-nowrap">
          {{ data.item.maxAnalPeriod }}
        </span>
      </template>

      <!-- Column: maxCateNum -->
      <template #cell(line)="data">
        <span class="text-nowrap">
          {{ data.item.maxCateNum }}
        </span>
      </template>

      <!-- Column: maxMemNum -->
      <template #cell(maxMemNum)="data">
        <span class="text-nowrap">
          {{ data.item.maxMemNum }}
        </span>
      </template>

      <!-- Column: openMenu -->
      <template #cell(openMenu)="data">
        <span class="text-nowrap">
          {{ data.item.openMenu }}
        </span>
      </template>

      <template #cell(actions)="data">
        <div class="text-nowrap">
          <feather-icon
            v-if="hasSuperAdminRole()"
            icon="Edit2Icon"
            class="cursor-pointer mr-1"
            size="16"
            @click="updatePrice(data.item)"
          />
          <feather-icon
            v-if="hasSuperAdminRole()"
            icon="Trash2Icon"
            class="cursor-pointer"
            size="16"
            @click="deletePrice(data.item.id)"
          />
        </div>
      </template>
    </b-table>

    <b-row class="mt-1">
      <b-col
        cols="12"
        sm="6"
        class="d-flex align-items-center justify-content-center justify-content-sm-start"
      >
        <span class="text-muted">
          Showing {{ dataMeta.from }} to {{ dataMeta.to }} of
          {{ dataMeta.of }} entries
        </span>
        <b-form-group class="text-nowrap mb-md-0 ml-1">
          <b-form-select
            id="perPageSelect"
            v-model="perPage"
            size="sm"
            inline
            :options="perPageOptions"
          />
        </b-form-group>
      </b-col>
      <!-- Pagination -->
      <b-col
        cols="12"
        sm="6"
        class="d-flex align-items-center justify-content-center justify-content-sm-end"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="totalPrices"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </b-col>
    </b-row>

    <add-price-modal 
      :refreshData="reFetchData"
    />
    <update-price-modal
      :updatingPrice="updatingPrice"
      :refreshData="reFetchData"
    />
  </b-card>
</section>
</template>

<script>
import {
  BCard,
  BCol,
  BRow,
  BCardBody,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BTable,
  BLink,
  BTooltip,
  BPagination,
  BFormRadio,
} from "bootstrap-vue";
import cisPricesList from "@/views/cis-settings/components/cisPricesList";
import UpdatePriceModal from "@/views/cis-settings/modal/UpdatePriceModal";
import AddPriceModal from "@/views/cis-settings/modal/AddPriceModal";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import vSelect from "vue-select";

import CISSettingService from "@/services/cis-setting.service";

export default {
  name: "CisPrices",
  components: {
    BCard,
    BCol,
    BRow,
    BCardBody,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BTable,
    BLink,
    BTooltip,
    BPagination,
    UpdatePriceModal,
    AddPriceModal,
    vSelect,
    BFormRadio,
  },
  data() {
    return {
      updatingPrice: null,
      selectedAdminMenu: "prices",
    };
  },
  computed:{
    check_adminMenu() {
      return this.$store.getters.getSelectedAdminMenu
    }
  },
  watch: {
    check_adminMenu(value) {
      this.selectedAdminMenu = value
    }
  },
  methods: {
    async loadData(){
      this.reFetchData()
    },
    adminMenuClick(mode) {      
      this.$store.dispatch('callAdminMenu', { adminMenu: mode })

      switch(mode) {
        case 'account':
          this.$router.push({ name: "cis-account" }).catch(() => {});
          break;
        case 'prices':
          this.$router.push({ name: "cis-prices" }).catch(() => {});
          break;
        case 'users':
          this.$router.push({ name: "cis-users" }).catch(() => {});
          break;
        case 'seeds':
          this.$router.push({ name: "cis-seeds" }).catch(() => {});
          break;
        case 'keywords':
          this.$router.push({ name: "cis-keywords" }).catch(() => {});
          break;
        case 'synonyms':
          this.$router.push({ name: "cis-synonyms" }).catch(() => {});
          break;
        case 'uncategorized':
          this.$router.push({ name: "cis-uncategorized" }).catch(() => {});
          break;
      }

      
    },

    
    deletePrice(id) {
      this.$swal({
        title: "Are you sure?",
        html: "You want to delete the Price!<br>&nbsp;",
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
        padding: "1rem"
      }).then(async (result) => {
        if (result.isConfirmed) {
          const deleteResponse = await CISSettingService.deletePrice({priceSq: id});
          if (deleteResponse.status === 200) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Successfully deleted!",
                icon: "TrashIcon",
                variant: "success",
              },
            });
            this.reFetchData();
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || "Unknown error",
                icon: "AlertCircleIcon",
                variant: "danger",
              },
            });
          }
        }
      });
    },
    updatePrice(price) {
      this.updatingPrice = price;
      this.$bvModal.show("update-price-modal");
    },
    addPrice() {
      console.log('-- add price --')
      this.$bvModal.show("add-price-modal");
    },
  },
  setup() {
    const {
      fetchPrices,
      tableColumns,
      perPage,
      currentPage,
      totalPrices,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refPricesTable,

      statusFilter,

      reFetchData
    } = cisPricesList();

    return {
      fetchPrices,
      tableColumns,
      perPage,
      currentPage,
      totalPrices,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refPricesTable,

      statusFilter,

      reFetchData
    };
  },
  created() {
    
  },
};
</script>

<style lang="scss">

.mb-1 .sticky-top{
  align-self: flex-start;
}

#adminMenu .btn-radio .btn-secondary {
  background-color: #4E86FF !important;
  border-color: #4E86FF !important;
  box-shadow: none;
}


#adminMenu .btn-radio .btn-secondary.active {
  background-color: #1951dc !important;
  border-color: #1c5cff !important;
  // box-shadow: 0 6px 30px -6px #002896;
  // font-weight: 600;
  // font-size: 1.3rem;
}

.cissetting .card-body {
  padding: 1.0rem;
}

.adaccount-select {
  font-size: large;

  .vs__dropdown-toggle {
    height: 80px;
  }

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}

</style>
